<template>
	<div id="viewAbout">
		<section class="post">
			<header class="major">
				<h2>Über uns</h2>
			</header>

			<div style="padding-bottom:2em;"><img width="100%" src="/images/team.jpeg"></div>
			
			<p>Wir sind ein Verbund aus Weitgereisten und kreativen Köpfen, die trotz der aktuellen Situation gemeinsam auf Reisen gehen möchten. Dazu stellen wir wöchentlich ein digitales Reiseabenteuer mit unseren Referenten kostenfrei als Livestream zur Verfügung, um unsere Herzensprojekte finanziell zu unterstützen.
			</p>
			<h3>Wir sind</h3>
			<div class="initiatoren row text-center">
				<div v-for="(initiator,index) in initiatoren" :key="index" class="col_initiatoren col-4 col-6-medium col-12-small">
					<div class="col_initiatoren_img_wrapper"><a class="no-deco" rel="noreferrer" target="_blank" :href="initiator.link"><img :class="initiator.class" class="logo_initiator p-1" :alt="initiator.alt" :src="initiator.img"></a></div>
					<div><a class="no-deco" target="_blank" rel="noreferrer"  :href="initiator.link">{{initiator.link}}</a></div>
				</div>
			</div>
		</section>
  </div>
</template>

<script>
import {helper} from '@/mixins/helper.js'
  export default {
	name: 'ViewAbout',
	mixins:[helper],
    components: {
  },
  data(){
	return {
			initiatoren:[{
				"name":"radzelten",
				"link":"https://radzelten.de",
				"alt":"Radzelten",
				"img":"/images/logos/radzelten.png"
			},
			{
				"name":"Weltsichten",
				"link":"https://www.weltsichten.de",
				"alt":"Weltsichten",
				"img":"/images/logos/weltsichten.png",
				"class":"pt-3"
			},
			{
				"name":"prosa - clever clothing",
				"link":"https://prosa-clothing.com",
				"alt":"prosa - clever clothing",
				"img":"/images/logos/prosa.png",
				"class":"pt-3"
			},
			{
				"name":"Schere Stein Papier",
				"link":"https://www.scheresteinpapier.cc",
				"alt":"Schere Stein Papier",
				"img":"/images/logos/scheresteinpapier.png",
				"class":"pt-3"
			}]
		}
		/*
		{
				"name":"DIAlle - ein Reisefestival",
				"link":"https://dialle-halle.de",
				"alt":"DIAlle",
				"img":"/images/logos/dialle.png"
			}
		*/
  },
  methods:{
	getMaxWidthOfPlayer(){
		return this.isSmallTouchDevice()?300:640;
	},
	getHeightOfPlayer(){
		return this.isSmallTouchDevice()?200:360;
	}
  },
  }
</script>

<style scoped>
.col_initiatoren_img_wrapper{
	height:150px;
}
.initiatoren img{
	max-width:300px;
	max-height: 150px;
	padding:1rem;
}
</style>
